import $ from '../common/jquery.js';
import sample from '../utils/sample.js';

export class Player {
  constructor (sounds, $recordTable, notes, domain) {
    this.bass = sounds.loadBass();
    this.mids = sounds.loadMids();
    this.highs = sounds.loadHighs();
    this.drums = sounds.loadDrums();
    this.vocals = sounds.loadVocals();
    this.$recordTable = $recordTable;
    this.notes = JSON.parse(notes);
    this.domain = domain;

    this.counter = 0;
    this.displayRows = $(this.$recordTable).length;
    this.displayCounter = 0;
    this.playing = false;
    this.row = 0;
    this.col = 0;
    this.grid = this.loadGrid(this.domain);
    this.events();
  }

  loadGrid () {
    if (this.domain.length % 2 === 0)
      return [
        [['k', 'b'], ['h'], ['b', 'h', 'm'], ['b']],
        [['h', 'b', 's', 'm'], ['h'], ['b', 'h', 'm'], ['m']],
        [['k', 'b'], ['h', 'b'], ['b'], ['h']],
        [['h', 'b', 's'], ['h'], ['b', 'h'], ['s', 'b']]
      ];
    else
      return [
        [['k', 'b'], ['b', 'm'], ['b', 'm', 's', 'h', 'k'], ['b']],
        [['s', 'h', 'b'], ['b'], ['b', 'h'], ['b']],
        [['k', 'm'], ['b'], ['b', 'm', 'h'], ['b', 'k']],
        [['s', 'b'], ['b'], ['b', 'h', 'm'], ['b', 'k']]
      ];
  }

  events () {
    $(document).on('click', '.js-play', () => {
      if (!this.playing) {
        this.playInterval = setInterval(() => this.play(), 180);
        this.showPauseState();
      } else {
        clearInterval(this.playInterval);
        this.playing = false;
        this.showPlayState();
      }
    });

    ['.js-kick', '.js-snare', '.js-hat', '.js-bass', '.js-mids', '.js-party'].forEach(element => {
      $(document).on('click', element, () => {
        $(element).toggleClass('active');
      });
    });

    $(document).on('click', '.js-party', () => {
      this.partyMode();
    });

    return this.draggableCat();
  }

  stop () {
    clearInterval(this.playInterval);
    this.playing = false;
    this.showPlayState();
  }

  draggableCat () {
    return $('body').on('mousedown', '.js-party-paw', e => {
      $('.js-party-paw').addClass('paw-draggable');
      $('.paw-draggable').parents().on('mousemove', e => {
        return $('.paw-draggable').offset({
          top: e.pageY - ($('.js-party-paw').outerHeight() / 2),
          left: e.pageX - ($('.js-party-paw').outerWidth() / 2)
        }).on('mouseup', () => $('.js-party-paw').removeClass('paw-draggable'));
      });
      return e.preventDefault();
    }).on('mouseup', () => $('.js-party-paw').removeClass('paw-draggable'));
  }

  partyMode () {
    if ($('.js-party').hasClass('active')) {
      if (!this.playing)
        $('.js-play').click();

      $('.js-party-paw').removeClass('is-hidden');
      this.vocals.r.play();
    } else {
      $('.js-party-paw').addClass('is-hidden');
      this.vocals.o.play();
    }

    $('.js-kick').addClass('active');
    $('.js-snare').addClass('active');
    $('.js-hat').addClass('active');
    $('.js-bass').addClass('active');
    $('.js-mids').addClass('active');
  }

  play () {
    this.playing = true;

    const instruments = this.grid[this.row][this.col];

    for (const instrument of [...instruments])
      switch (instrument) {
        case 'm': this.playLead(); break;
        case 'b': this.playBass(); break;
        case 'k': this.playKick(); break;
        case 's': this.playSnare(); break;
        case 'h': this.playHat(); break;
      }

    this.col++;
    if (this.col === 4) {
      this.row++;
      this.col = 0;
    }
    if (this.row === 4)
      this.row = 0;

    this.display();
  }

  playLead () {
    if (this.counter === (this.notes.length - 1))
      this.counter = 0;

    if ($('.js-mids').hasClass('active')) {
      const note = this.notes[this.counter];
      if (this.mids[note]) sample([this.highs[note], this.mids[note]]).play();
    }

    return this.counter++;
  }

  playBass () {
    if (this.counter === (this.notes.length - 1))
      this.counter = 0;

    if ($('.js-bass').hasClass('active')) {
      const note = this.notes[this.counter];
      if (this.bass[note]) this.bass[note].play();
    }

    return this.counter++;
  }

  playKick () {
    if ($('.js-kick').hasClass('active'))
      return this.drums.k.play();
  }

  playSnare () {
    if ($('.js-snare').hasClass('active'))
      return this.drums.s.play();
  }

  playHat () {
    if ($('.js-hat').hasClass('active'))
      return this.drums.h.play();
  }

  display () {
    if (this.displayCounter === this.displayRows)
      this.displayCounter = 0;
    $($(this.$recordTable)[this.displayRows - 1]).css('background', '#fff');

    if (this.displayCounter > 0)
      $($(this.$recordTable)[this.displayCounter - 1]).css('background', '#fff');

    if ($('.js-party').hasClass('active'))
      $($(this.$recordTable)[this.displayCounter]).css('background', sample(['#ff00ff', '#7fff00', '#ffff00', '#00ffff', '#000fff', '#ff0000']));
    else
      $($(this.$recordTable)[this.displayCounter]).css('background', 'tomato');

    return ++this.displayCounter;
  }

  showPlayState () {
    $('.js-play').removeClass('active');
  }

  showPauseState () {
    $('.js-play').addClass('active');
  }
};

export default Player;
